import { P_PARAMETER_LIST } from '@ho/shared/constants/p-parameter.interface';
import { isArray, isNil } from 'lodash-es';
const _checkEmptyParameters = (data) => {
    return !P_PARAMETER_LIST.some((p) => !isNil(data[p]) && (isArray(data[p]) ? data[p].length : data[p] !== ''));
};
export const prepareExtraParametersP = (data, joinBy = '\n') => {
    if (_checkEmptyParameters(data)) {
        return null;
    }
    const existingParams = P_PARAMETER_LIST.filter((p) => !isNil(data[p]) && (isArray(data[p]) ? data[p].length : data[p] !== ''));
    return existingParams
        .map((p) => {
        if (isArray(data[p])) {
            return `${p}: ${data[p].join(', ')}`;
        }
        return `${p}: ${data[p]}`;
    })
        .join(joinBy);
};
